var debug = true;

function searchToggle() {
  const searchToggler = document.getElementById("search-btn");
  const resultsBlock = document.getElementById("search-results-wrap");
  const html = document.documentElement;

  searchToggler.addEventListener("click", () => {
    resultsBlock.classList.toggle("show");
    searchToggler.classList.toggle("open-search");
    html.classList.toggle("-search-open");
  });
}
searchToggle();